import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { MatrixModel } from "@models/generic/MatrixModel";

@Injectable()
export class SharedDataService extends ApiDataService {
    constructor() {
        super("shared");
    }

    getOrganizationMatrix(organizationID: number) {
        return this.http.get<MatrixModel>(this.actionUrl + `/${organizationID}/organizationmatrix`);
    }

    getDefaultMatrix() {
        return this.http.get<MatrixModel>(this.actionUrl + `/organizationmatrix`);
    }
}
